/**
 * Donation overlay logic.
 */
( function ( $ ) {

	/**
	 * Check if the donation form is used in the main wrapper (our overlay is set outside that div) before we load the
	 * overlay.
	 */
	if ( $( '.main-wrapper #donation-form' ).length ) {
		return;
	}

	/**
	 * Check for IE.
	 * If IE send the user to the fallback url.
	 *
	 * @url https://stackoverflow.com/a/21712356/9266969
	 */
	if ( window.document.documentMode ) {
		$( 'a[href*="#donation-form"]' ).attr( 'href', dfoSettings.fallbackUrl );

		return;
	}

	/**
	 * Object to contain all logic.
	 *
	 * @type {{}}
	 */
	var donationOverlay = {};

	/**
	 * Open modal.
	 *
	 * @param {object,false} event
	 */
	donationOverlay.modalOpen = function( event = false ) {
		if ( event ) {
			event.preventDefault();
		}

		$( '.donation-overlay' ).fadeIn( 200 );

		// Add overflow hidden to body so we do not have a scrolling page behind the overlay.
		// @see donationOverlay.modalClose
		$( '.box-wrapper' ).addClass( 'webkit-overlay-hack' );

		$('.donation-overlay__form-title').focus();
	};

	/**
	 * Method to close the overlay modal.
	 */
	donationOverlay.modalClose = function() {
		$( '.donation-overlay' ).fadeOut( 100 );
		// Remove overflow hidden on body so the page can scroll again.
		// @see donationOverlay.modalOpen
		$( '.box-wrapper' ).removeClass( 'webkit-overlay-hack' );
	};

	/**
	 * Add toggle logic to all donation links.
	 *
	 * We bind the event to body since the "open" logic should also
	 * work on buttons that are potentially loaded after the initial
	 * DOM load.
	 */
	$( 'body' ).on( 'click', 'a[href*="#donation-form"]', donationOverlay.modalOpen );

	/**
	 * Close overlay on "Esc" key press.
	 *
	 * @param {object} event
	 */
	$( document ).keyup( function( event ) {
		if ( event.keyCode == 27 ) {
			donationOverlay.modalClose();
		}
	} );

	/**
	 * Close overlay on "X" click.
	 *
	 * @param {object} event
	 */
	$( '.donation-overlay__close' ).on( 'click', function( event ) {
		event.preventDefault();
		donationOverlay.modalClose();
	} );

	if ( window.location.hash ) {
		var hash = window.location.hash;
		if ( hash.indexOf('#donation-form') !== -1 ) {
			donationOverlay.modalOpen();
		}
	}

} )( jQuery );
